import { Chat, ChatHistory, ChatMessage } from '@app/types/chat';
import { createContext, Dispatch, SetStateAction } from 'react';
import { OpenAIAssistant, TokenUsage } from '@api/openai/model/types.ts';

interface ChatContextProps {
  chats: Chat[];
  chatHistory: ChatHistory | null;
  selectedChatId: number | null;
  createNewChat: (type: string) => void;
  getUserChatHistory: (requestId?: number) => void;
  selectChat: (chatId: number | null) => void;
  editUserChat: (id: number, name: string) => void;
  deleteUserChat: (chatId: number) => void;
  chatType: string;
  setChatType: (type: string) => void;
  messages: { [key: number]: ChatMessage[] };
  openAIAssistant: OpenAIAssistant | null;
  tokenUsage: TokenUsage | null;
  monthlyTokenUsage: TokenUsage | null;
  setOpenAIAssistant: Dispatch<SetStateAction<OpenAIAssistant | null>>;
  setTokenUsage: Dispatch<SetStateAction<TokenUsage | null>>;
  setMonthlyTokenUsage: Dispatch<SetStateAction<TokenUsage | null>>;
  setMessages: Dispatch<SetStateAction<{ [key: number]: ChatMessage[] }>>;
  setDraftMessage: (message: ChatMessage) => void;
  isLoading: boolean;
  setIsLoading: Dispatch<SetStateAction<boolean>>;
  errorMessage: boolean;
  setErrorMessage: Dispatch<SetStateAction<boolean>>;
  setMessagesByChatId: (
    chatId: number,
    newMessages:
      | ChatMessage[]
      | ((prevMessages: ChatMessage[]) => ChatMessage[])
  ) => void;
}

const ChatContext = createContext<ChatContextProps>({} as ChatContextProps);

export default ChatContext;
